import { render } from "./company-edit-modal.vue?vue&type=template&id=147c2a0b&ts=true"
import script from "./company-edit-modal.vue?vue&type=script&lang=ts"
export * from "./company-edit-modal.vue?vue&type=script&lang=ts"

import "./company-edit-modal.vue?vue&type=style&index=0&id=147c2a0b&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__